/**
 * Personal | Business | All toggle used across finance screens.
 */
export default function ScopeToggle({ value, onChange, testId = "scope-toggle" }) {
  const options = [
    { key: "all", label: "Todo" },
    { key: "personal", label: "Personal" },
    { key: "business", label: "Negocio" },
  ];
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center gap-1 p-1 rounded-lg bg-black/40 border border-white/8"
    >
      {options.map((o) => {
        const active = value === o.key;
        return (
          <button
            key={o.key}
            data-testid={`${testId}-${o.key}`}
            onClick={() => onChange(o.key)}
            className={`px-3 py-1.5 rounded-md text-[11px] font-mono uppercase tracking-[0.14em] font-bold transition ${
              active
                ? "bg-white/10 text-white"
                : "text-white/40 hover:text-white/70"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
